export default "__VITE_ASSET__57484c1c__"